@let vm =
    {
        isCarServiceRequested: isCarServiceRequested$ | async,
    };

<div id="car-service-tab" class="tab flex flex-col gap-medpace">
    @if (!isCarServiceAvailable()) {
        <medpace-alert [appearance]="'highlight'" [content]="nonAvailableMessage" />
    }
    @if (isCarServiceAvailable() || vm.isCarServiceRequested) {
        <medpace-needs-travel-radio-group
            [label]="'Will the patient need a car service?'"
            [isDisabled]="false"
            [isUpdate]="isUpdate()"
            [formCtrl]="formGroup().controls.needsTravel"
        />
        @if (formGroup().controls.needsTravel.value) {
            <div>
                <mds-divider />
                <mds-expansion-panel
                    class="expansion-panel-request !border-y-0"
                    [panelTitle]="'Car Service Preferences'"
                    [description]="'(from Patient Profile)'"
                >
                    <medpace-transfer-preferences
                        [formGroup]="formGroup().controls.travel.controls.preferences"
                        [mode]="'view'"
                    />
                </mds-expansion-panel>
                <mds-divider />
            </div>
            @if (mode() === 'edit') {
                <medpace-transfer-request-details-edit
                    [formGroup]="formGroup().controls.travel.controls.requestDetails"
                />
            } @else if (mode() === 'view') {
                <medpace-transfer-request-details-view
                    [formGroup]="formGroup().controls.travel.controls.requestDetails"
                />
            }
        }
    }
</div>
